import { createAsyncThunk } from "@reduxjs/toolkit";
import { getReportProblem, updateReportProblem } from "store/services/reportProblem";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllReportProblemAction = createAsyncThunk(
  "reportProblem/getAllReportProblem",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getReportProblem(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const UpdateReportAction = createAsyncThunk(
  "reportProblem/updateReportProblem",
  async (payload, { rejectWithValue, fulfillWithValue, dispatch }) => {
    const { filter, onSuccess, onError, ...rest } = payload; 
    try {
      const res = await updateReportProblem(rest);
      if (res.status === 1) {
        const response = await getReportProblem(filter);
        if (response.status === 1) {
          onSuccess?.(response); 
          return fulfillWithValue(response);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      onError?.(res); 
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      onError?.(error); 
      return rejectWithValue(error);
    }
  }
);
